module.exports = __webpack_public_path__ + "static/media/awareness-check-mental-health-svgrepo-com.ddd27e98.svg";